import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DataContext } from '../../context/DataContext';
import { getTokens } from '../../theme';

// Pill de estado — ver README.md (StatusChip).
// tone: 'success' | 'warning' | 'error' | 'info' | 'neutral'
const StatusChip = ({ label, tone = 'neutral', sx }) => {
	const theme = useTheme();
	const { isDarkMode } = useContext(DataContext);
	const t = getTokens(isDarkMode);

	const toneColors = {
		success: { fg: theme.palette.success.main, bg: theme.palette.success.light },
		warning: { fg: theme.palette.warning.main, bg: theme.palette.warning.light },
		error: { fg: theme.palette.error.main, bg: theme.palette.error.light },
		info: { fg: theme.palette.info.main, bg: theme.palette.info.light },
		neutral: { fg: t.ink3, bg: t.soft }
	};

	const colors = toneColors[tone] || toneColors.neutral;

	return (
		<Box
			component="span"
			sx={{
				display: 'inline-block',
				fontSize: 11,
				fontWeight: 600,
				padding: '3px 11px',
				borderRadius: '20px',
				color: colors.fg,
				backgroundColor: colors.bg,
				whiteSpace: 'nowrap',
				...sx
			}}
		>
			{label}
		</Box>
	);
};

export default StatusChip;
